import React from 'react';
import GrammarPageLayout from '../components/grammar-page-layout';
import GrammarExplanation from '../components/explanations/adj-adv-explanation';
const mainimage = '/Images/adjadv.webp';

const sections = [
  { label: "Grammar", description: "Do this exercise to practice grammar.", type: "quiz", subtype: "adjadv" },
];

const Adjadv = () => (
  <GrammarPageLayout
    level="B2"
    title="Adjadv"
    image={mainimage}
    ExplanationComponent={GrammarExplanation}
    sections={sections}
    seoTitle="Free English Adjectives and Adverbs Exercises"
    seoDescription="Use adjectives and adverbs accurately including comparative/superlative forms. B2 level exercises."
    relatedCategory="grammar-exercises"
    relatedLevel="B2"
  />
);

export default Adjadv;

